"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.singleConfigurationFlowNavigatorDefinition = void 0;
const configuration_search_params_1 = require("./configuration-search-params");
exports.singleConfigurationFlowNavigatorDefinition = {
    id: 'single-configuration-flow-navigator',
    dependencies: {
        featureServices: {
            'navigation-service': '^1.1.0',
        },
    },
    optionalDependencies: {
        featureServices: {
            's2:logger': '^1.0.0',
        },
    },
    create: ({ featureServices }) => {
        const { 'navigation-service': navigationService, 's2:logger': logger = console, } = featureServices;
        const createNavigation = (mofaPathname, options = {}, configuration) => {
            const { mofaPageId = 'mofa-standalone', mofaFeatureAppConfigName = 'mofa-standalone', } = options;
            const search = configuration
                ? (0, configuration_search_params_1.createSearchParamsForConfiguration)(configuration).toString()
                : undefined;
            const navigationTarget = navigationService.navigateTo(mofaPageId, {
                [mofaFeatureAppConfigName]: { pathname: mofaPathname, search },
            });
            if (!navigationTarget) {
                logger.debug(`Unable to create navigation target to MOFA path ${mofaPathname} using pageId ${mofaPageId}.`);
                return undefined;
            }
            return {
                href: navigationTarget.createHref(),
                onClick: () => navigationTarget.push(),
            };
        };
        return {
            '1.2.0': () => ({
                featureService: {
                    createConfigureNavigation: (configuration, options) => createNavigation('/route:configure', options, configuration),
                    createChangeTrimNavigation: (configuration, options) => createNavigation('/route:changeTrim', options, configuration),
                    createNodeNavigation: (nodeId, options) => {
                        const encodedNodeId = nodeId
                            .split('/')
                            .map(encodeURIComponent)
                            .join('/');
                        return createNavigation(encodedNodeId, options);
                    },
                },
            }),
        };
    },
};
//# sourceMappingURL=index.js.map